'use strict';

module.exports = {
    communicationService: 'communicationService',
    storageServer: 'storageServer',
    jetServer: 'jet',
    flight: 'flight',
    objectStorage: 'objectStorage',
    commandRequest: 'commandRequest',
    cloudConfig: 'cloudConfig',
    mediaEngine: 'mediaEngine'
};